import React from 'react';
import { createPortal } from 'react-dom';
import { Toaster, toast, resolveValue } from 'react-hot-toast';
import { ReactComponent as LogoNotification } from 'src/assets/images/onboarding-trainer/logo-of-notification.svg';
import './CustomToaster.scss';

export const CustomToaster = () => {
  if (typeof document === 'undefined') return null;

  return createPortal(
    <Toaster
      position="top-right"
      toastOptions={{ duration: 4000 }}
      containerClassName="custom-toaster"
      containerStyle={{ zIndex: 9999999 }}
    >
      {(t) => {
        let title = 'Notification';
        const description = resolveValue(t.message, t);

        if (t.type === 'success') title = 'Success';
        if (t.type === 'error') title = 'Error';
        if (t.type === 'loading') title = 'Loading';

        return (
          <div className="custom-toaster-wrapper" style={{ opacity: t.visible ? 1 : 0 }}>
            <div className="toaster-icon-wrapper">
              <LogoNotification />
            </div>
            <div className="toaster-content">
              <div className="toaster-title">{title}</div>
              <div className="toaster-description">{description}</div>
            </div>
            <button className="toaster-close-btn" onClick={() => toast.dismiss(t.id)}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
        );
      }}
    </Toaster>,
    document.body,
  );
};
